
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 0C3.983 0 2.617.62 1.623 1.614L.486.478 0 3.842 3.409 3.4 2.268 2.26A4.557 4.557 0 015.5.917 4.589 4.589 0 0110.083 5.5 4.588 4.588 0 015.5 10.083 4.584 4.584 0 011.425 7.59l-.787.479A5.496 5.496 0 005.5 11a5.5 5.5 0 000-11z","fill":"#161619"}})])
          )
        }
      }
    